import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import NotificationGrid from 'flarum/forum/components/NotificationGrid';
import Checkbox from 'flarum/common/components/Checkbox';

const t = (key) => app.translator.trans(`happydigital-notification-settings.forum.types.${key}`);

// happydigital/flarum-stories registers these types but never adds grid rows
// for them, so users could not switch them off. Priorities place them after
// the core/likes/mentions rows.
const STORY_TYPES = [
  { name: 'storyLiked', icon: 'fas fa-heart', labelKey: 'story_liked_label', priority: -100 },
  { name: 'storyMentioned', icon: 'fas fa-at', labelKey: 'story_mentioned_label', priority: -110 },
  { name: 'storyReplied', icon: 'fas fa-reply', labelKey: 'story_replied_label', priority: -120 },
];

/**
 * Email notifications are not offered on this forum; the column is replaced
 * by the push driver's column (notify_{type}_push preferences).
 */
export default function adjustNotificationGrid() {
  extend(NotificationGrid.prototype, 'notificationMethods', function (items) {
    if (items.has('email')) items.remove('email');

    items.add('push', { name: 'push', icon: 'fas fa-mobile-alt', label: t('push_column') }, -10);
  });

  // Push only exists for a few types (src/PushTypes.php); for the rest core
  // renders a disabled checkbox because the preference is missing. Drop it
  // so those rows show an empty push cell instead of a dead control.
  extend(NotificationGrid.prototype, 'view', function (vdom) {
    const tbody = (vdom.children || []).find((child) => child && child.tag === 'tbody');
    if (tbody) removeUnavailableCheckboxes(tbody);
  });

  extend(NotificationGrid.prototype, 'notificationTypes', function (items) {
    if (!flarum.extensions['happydigital-stories']) return;

    STORY_TYPES.forEach(({ name, icon, labelKey, priority }) => {
      if (!items.has(name)) items.add(name, { name, icon, label: t(labelKey) }, priority);
    });
  });
}

// NotificationGrid marks a checkbox `disabled` exactly when its preference
// key does not exist, i.e. that type/method combination is unavailable.
function removeUnavailableCheckboxes(vnode) {
  if (!vnode || !Array.isArray(vnode.children)) return;

  vnode.children = vnode.children.map((child) => (child && child.tag === Checkbox && child.attrs && child.attrs.disabled ? null : child));
  vnode.children.forEach(removeUnavailableCheckboxes);
}
